import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { Chip } from "@mui/material";
import { colord } from "colord";
import React from "react";
import { ellipsisStyle } from "../text/Ellipsis.js";
export const StatusChip = React.forwardRef(({ endIcon, backgroundColor, textColor, icon, label, variant = "filled", size = "small", ...props }, ref) => (_jsx(Chip, { ref: ref, component: "span", icon: icon, label: endIcon ? (_jsxs(_Fragment, { children: [_jsx("span", { style: ellipsisStyle, children: label }), _jsx("span", { style: {
                    display: "inline-flex",
                    height: "1em",
                    alignItems: "center",
                    width: "24px",
                    marginLeft: "2px",
                    marginRight: "-4px",
                    alignSelf: "center",
                }, children: endIcon })] })) : (label), variant: variant, size: size, sx: {
        textTransform: "uppercase",
        fontWeight: "normal",
        height: "auto",
        ...(backgroundColor
            ? {
                backgroundColor,
                ...(props.onClick && !props.disabled
                    ? {
                        ["&:hover, &:active"]: {
                            backgroundColor: colord(backgroundColor).isDark()
                                ? colord(backgroundColor).lighten(0.1).toHex()
                                : colord(backgroundColor).darken(0.1).toHex(),
                        },
                    }
                    : undefined),
            }
            : undefined),
        ...ellipsisStyle,
        ".MuiChip-label": {
            display: "inline-flex",
            textAlign: "center",
            fontWeight: 500,
            ...ellipsisStyle,
            ...(textColor ? { color: textColor } : undefined),
        },
    }, ...props })));
//# sourceMappingURL=StatusChip.js.map